import React, { createContext, useContext, useState } from 'react';

const PromptContext = createContext();

export const usePromptContext = () => useContext(PromptContext);

export const PromptProvider = ({ children }) => {
    const [contextSubmitPrompt , setPrompt] = useState("");

    const updatePrompt = (newPrompt) => {
        setPrompt(newPrompt);
    };

    return (
        <PromptContext.Provider value={{ contextSubmitPrompt , updatePrompt }}>
            {children}
        </PromptContext.Provider>
    );
};
